(function () {
  'use strict';

  /* ===========================================
     PENNY — Product Detail Page (Phase 04)
     Product Hero Behaviors
     =========================================== */

  // --- Product Image Progressive Reveal (Intersection Observer) ---
  (function initImageReveal() {
    var galleryItems = document.querySelectorAll('.product-hero-penny__gallery-item');
    if (!galleryItems.length) return;

    if ('IntersectionObserver' in window) {
      var imageObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              imageObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );

      Array.prototype.forEach.call(galleryItems, function (el) {
        imageObserver.observe(el);
      });
    } else {
      // Fallback: make all visible immediately
      Array.prototype.forEach.call(galleryItems, function (el) {
        el.classList.add('is-visible');
      });
    }
  })();

  // --- Desktop Carousel ---
  (function initCarousel() {
    var carousel = document.querySelector('.product-hero-penny__carousel');
    if (!carousel) return;

    var slidesContainer = carousel.querySelector('.product-hero-penny__slides');
    if (!slidesContainer) return;

    var slides = slidesContainer.querySelectorAll('.product-hero-penny__slide');
    if (!slides.length) return;

    var dots = carousel.querySelectorAll('.product-hero-penny__dot');
    var currentIndex = 0;
    var intervalId = null;

    // Read settings from data attributes
    var autoplay = carousel.getAttribute('data-autoplay') !== 'false';
    var intervalMs = parseInt(carousel.getAttribute('data-interval'), 10) || 4000;

    function showSlide(index) {
      // Clamp index
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      // Update slides
      Array.prototype.forEach.call(slides, function (slide, i) {
        if (i === index) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });

      // Update dots
      Array.prototype.forEach.call(dots, function (dot, i) {
        if (i === index) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });

      currentIndex = index;
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      intervalId = setInterval(function () {
        showSlide(currentIndex + 1);
      }, intervalMs);
    }

    function stopAutoplay() {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    // Dot click handlers
    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-target'), 10);
        if (!isNaN(target)) {
          showSlide(target);
          startAutoplay(); // Reset interval on click
        }
      });
    });

    // Click to advance (when data-click-advance is present)
    if (carousel.hasAttribute('data-click-advance')) {
      carousel.addEventListener('click', function (e) {
        if (e.target.closest('.product-hero-penny__dot')) return;
        showSlide(currentIndex + 1);
        startAutoplay();
      });
    }

    // Show first slide
    showSlide(0);

    // Start autoplay
    startAutoplay();

    // Pause on hover (user experience)
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
  })();

  // --- Size Selector Cross-Sync ---
  // Syncs active state between mobile (sticky bar) and desktop size selectors.
  // Each selector's buttons fire a click handler that toggles .is-active on
  // the clicked button and propagates to all other selectors on the page.
  (function initSizeSync() {
    var selectors = document.querySelectorAll('[data-size-selector]');
    if (!selectors.length) return;

    selectors.forEach(function (container) {
      var buttons = container.querySelectorAll('.product-size-selector-penny__option');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (this.disabled) return;

          var value = this.getAttribute('data-option-value');
          var variantId = this.getAttribute('data-variant-id');

          // Deactivate all in this container
          container.querySelectorAll('.product-size-selector-penny__option')
            .forEach(function (b) {
              b.classList.remove('is-active');
              b.removeAttribute('aria-pressed');
            });

          // Activate clicked
          this.classList.add('is-active');
          this.setAttribute('aria-pressed', 'true');

          // Sync all other size selector containers
          document.querySelectorAll('[data-size-selector]').forEach(function (other) {
            if (other === container) return;
            other.querySelectorAll('.product-size-selector-penny__option')
              .forEach(function (b) {
                b.classList.remove('is-active');
                b.removeAttribute('aria-pressed');
                if (b.getAttribute('data-option-value') === value) {
                  b.classList.add('is-active');
                  b.setAttribute('aria-pressed', 'true');
                }
              });
          });

          // Update hidden variant ID input across all forms
          if (variantId) {
            var inputs = document.querySelectorAll('input[name="id"]');
            Array.prototype.forEach.call(inputs, function (input) {
              input.value = variantId;
            });
          }

          // Update add-to-bag buttons: disable if variant unavailable
          // We check via the variant-for-size mapping in data-variant-id
          // For now, the initial state is set by Liquid; clicks on disabled
          // buttons are blocked above.
        });
      });
    });
  })();

  // --- Add-to-bag Sold-Out State ---
  // Listens for variant:change events (dispatched by size-selector snippet on
  // the section container) and updates add-to-bag button text to SOLD OUT
  // when the selected variant is unavailable.
  (function initAddToBag() {
    var section = document.querySelector('[data-section-id]');
    if (!section) return;

    section.addEventListener('variant:change', function (e) {
      var variantId = e.detail && e.detail.variantId;
      if (!variantId) return;

      // Find the matching size button to check availability
      var sizeBtn = document.querySelector(
        '[data-variant-id="' + variantId + '"]'
      );
      if (!sizeBtn) return;

      var isAvailable = !sizeBtn.disabled;
      var addToBagBtns = document.querySelectorAll(
        '.product-hero-penny__add-to-bag, .product-hero-penny__add-to-bag--desktop'
      );

      addToBagBtns.forEach(function (btn) {
        if (isAvailable) {
          btn.disabled = false;
          btn.textContent = 'ADD TO BAG';
        } else {
          btn.disabled = true;
          btn.textContent = 'SOLD OUT';
        }
      });
    });
  })();
})();
